import { Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Paper, SizingMultiplier, Typography } from '@ocx/ui';
import { TransactionIconBox } from '@ocx/ui-receipts';
import { DoNotDisturbIcon } from '@ocx/ui-icons';

import { messages } from './receipt-cancelled-transaction-card.messages';

export const ReceiptCancelledTransactionCard = () => {
  return (
    <Stack component={Paper} direction="row" spacing={SizingMultiplier.sm} alignItems="center">
      <TransactionIconBox>
        <DoNotDisturbIcon />
      </TransactionIconBox>
      <Typography variant="subtitle1">
        <FormattedMessage {...messages['receipt-cancelled-transaction-card:label']} />
      </Typography>
    </Stack>
  );
};
